import { INFO_ITEMS } from '@/utils/data/infos';

type InfoItem = (typeof INFO_ITEMS)[number];

export function InfoDescription({
  description,
  highlight,
}: Pick<InfoItem, 'description' | 'highlight'>) {
  const [before, after] = description.split(highlight);

  return (
    <>
      <p className="sr-only">
        {before}
        {highlight}
        {after}
      </p>
      <p aria-hidden="true" className="text-dark-blue/70 text-sm leading-relaxed">
        {before}
        <span className="font-roboto-medium text-midnight-blue">{highlight}</span>
        {after}
      </p>
    </>
  );
}
